import type { User } from 'shared/store/auth'
import { hasAdminPermission } from 'shared/lib/permissions/permissions'

export const canViewClientFinance = (user: User): boolean =>
	hasAdminPermission(user, 'finance_admin')
